import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router';
import {
  Box,
  BoxProps,
  Card, Grid, GridProps, styled,
} from '@mui/material';
import { ConfirmationDescription } from './ConfirmationDescription';
import { ConfirmationHeader } from './ConfirmationHeader';
import { ConfirmationActions } from './ConfirmationActions';
import { IAppReduxState, Plan } from '../../models';
import ExampleBill from './ExampleBill';
import UsageChargePeriod from './UsageChargePeriod';

const ConfirmationGrid = styled(Grid)<GridProps>(({ theme }) => ({
  backgroundColor: theme.palette.altBackground.main,
  height: '100%',
  padding: '50px 16px',
}));

const ConfirmationContentWrapper = styled(Box)<BoxProps>(({ theme }) => ({
  padding: '16px',
  [theme.breakpoints.up('sm')]: {
    padding: '32px',
  },
}));

type Props = {
  chartData?: Plan;
}

export function Confirmation({ chartData }: Props) {
  const selectedPlan = useSelector<IAppReduxState, string>((state) => state.userInput.selectedPlan);
  const selectedMeterId = useSelector<IAppReduxState, string>((state) => state.userInput.selectedMeterID);
  const stateCode = useSelector<IAppReduxState, string>((state) => state.account.stateCode);

  if (selectedPlan === '') return <Navigate to="/plans" />;

  return (
    <ConfirmationGrid container alignItems="center" justifyContent="center" sx={{ backgroundColor: 'mainBackground.main' }}>
      <Grid item>
        <Card sx={{ maxWidth: 685 }}>
          <ConfirmationHeader selectedPlan={selectedPlan} />
          <ConfirmationContentWrapper data-testid="descriptionWrapper">
            <ConfirmationDescription selectedPlan={selectedPlan} selectedMeterId={selectedMeterId} />
            <ExampleBill selectedPlan={selectedPlan} />
            <UsageChargePeriod stateCode={stateCode} selectedPlan={selectedPlan} passedChartData={chartData} />
          </ConfirmationContentWrapper>
          <ConfirmationActions selectedPlan={selectedPlan} selectedMeterId={selectedMeterId} />
        </Card>
      </Grid>
    </ConfirmationGrid>
  );
}

Confirmation.defaultProps = {
  chartData: undefined,
};
